import mime from 'mime-types';
const getFileMetadata = async (fileToRead) => {
    if (!(fileToRead instanceof File || fileToRead instanceof Blob)) {
        return false;
    } else {
        const readFile = (file) => {
            return new Promise((resolve, reject) => {
                if (window.FileReader && window.Blob) {
                    const filereader = new FileReader();
                    filereader.onloadend = (evt) => {
                        if (evt.target.readyState === FileReader.DONE) {
                            const uint = new Uint8Array(evt.target.result);
                            let bytes = [];
                            uint.forEach((byte) => {
                                bytes.push(byte.toString(16));
                            })
                            const hex = bytes.join('').toUpperCase();
                            resolve({
                                filename: file.name,
                                filetype: file.type ? file.type : 'Unknown/Extension missing',
                                binaryFileType: mime.contentType(getMimetype(hex)),
                                hex
                            })
                        }
                    }
                    const blob = file.slice(0, 4);
                    filereader.readAsArrayBuffer(blob);
                } else {
                    reject(new Error('FileReader or Blob is not supported by browser.'));
                }
            });
        };
        const metaData = await readFile(fileToRead);
        return metaData;
    }
};

const getMimetype = (signature) => {
    switch (signature) {
        case '89504E47':
            return 'image/png'
        case '47494638':
            return 'image/gif'
        case '25504446':
            return 'application/pdf'
        case 'FFD8FFDB':
        case 'FFD8FFE0':
        case 'FFD8FFE1':
        case 'FFD8FFE2':
            return 'image/jpeg'
        case '504B0304':
            return 'application/zip'
        default:
            return 'application/octet-stream'
    }
}

export default getFileMetadata;

export {
    getFileMetadata,
    getMimetype
}